import * as MUI from "@mui/material";
import { CardPessoaReconhecidaProps } from "../types/mandado-facial.types";
import { ComparacaoFotos } from "./comparacao-fotos";
import { DadosPessoais } from "./dados-pessoais";
import { ListaMandados } from "./lista-mandados";

export const CardPessoaReconhecida: React.FC<CardPessoaReconhecidaProps> = ({
  pessoa,
  fotoEnviada,
}) => {
  return (
    <MUI.Card
      sx={{
        mb: 3,
        p: 3,
        border: pessoa.statusPessoa ? "2px solid" : "1px solid",
        borderColor: pessoa.statusPessoa ? "error.main" : "divider",
        boxShadow: pessoa.statusPessoa ? 4 : 1,
      }}
    >
      {/* Header com Status */}
      {pessoa.statusPessoa && (
        <MUI.Alert
          severity="warning"
          sx={{
            mb: 2,
            backgroundColor: "error.main",
            color: "white",
            border: "2px solid",
            borderColor: "error.dark",
            fontWeight: "bold",
            "& .MuiAlert-icon": {
              color: "white",
            },
            "& .MuiAlert-message": {
              color: "white",
            },
          }}
        >
          <MUI.Typography
            variant="body2"
            fontWeight="bold"
            sx={{ color: "white" }}
          >
            {pessoa.statusPessoa}
          </MUI.Typography>
        </MUI.Alert>
      )}

      <MUI.Grid container spacing={3}>
        {/* Coluna das Fotos */}
        <MUI.Grid item xs={12} md={6}>
          <ComparacaoFotos
            fotoEnviada={fotoEnviada}
            fotoBanco={pessoa.foto}
            grauConfianca={pessoa.grauConfianca}
          />
        </MUI.Grid>

        {/* Coluna dos Dados */}
        <MUI.Grid item xs={12} md={6}>
          <DadosPessoais pessoa={pessoa} />
          <ListaMandados mandados={pessoa.mandados} />
        </MUI.Grid>
      </MUI.Grid>
    </MUI.Card>
  );
};
